import React, { Component } from "react";
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';

class FilterListHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        }
    }

    render() {

        var chevron = <FaChevronDown />;
        if (this.state.clicked == true) {
            chevron = <FaChevronUp />;
        }

        return (
            <div onClick={() => { this.setState({ clicked: !this.state.clicked }) }} style={{ display: "flex", flexDirection: "row", marginLeft: "7px", marginRight: "7px", paddingBottom: "5px" }}>
                <div style={{ flex: 4 }}>Search Filter</div>
                <div style={{ color: "#fff", flex: 1, maxWidth: "18px", marginRight: "3px", marginTop:"3px" }}>{chevron}</div>
            </div>
        );
    }
}

export default FilterListHeader;
